<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useCommunityCompaniesStore } from '@/stores/communityCompaniesStore';
import { useCommunityProviderStore } from '@/stores/communityProviderStore';
import { useCommunitiesStore } from '@/stores/communitiesStore';

const { t } = useI18n();
const router = useRouter();
const companiesStore = useCommunityCompaniesStore();
const providerStore = useCommunityProviderStore();
const communitiesStore = useCommunitiesStore();

companiesStore.fetchCommunityCompanies().catch(() => {});
if (!providerStore.allProviders.length)
  providerStore.fetchProviders().catch(() => {});
if (!communitiesStore.allCommunities.length)
  communitiesStore.fetchCommunities().catch(() => {});

const sortBy = [{ key: 'name', order: 'asc' }];

const tableHeader = computed(() => [
  { title: 'ECN', value: 'ecn' },
  { title: t('name'), value: 'name' },
  { title: t('communityProviders.legal'), value: 'legal' },
  { title: t('communityCompanies.communityProvider'), value: 'providerName' },
  { title: t('communityCompanies.communityCount'), value: 'communityCount' },
  { title: t('communityCompanies.memberCount'), value: 'memberCount' },
  { title: t('serviceFees.title'), value: 'feeCount' },
]);

function providerName(communityProvider) {
  if (!communityProvider) return '';
  const id = typeof communityProvider === 'object' ? communityProvider._id : communityProvider;
  const provider = providerStore.providerById.get(id);
  return provider ? provider.nameFriendly : '';
}

const rows = computed(() => companiesStore.allCommunityCompanies.map(c => ({
  ...c,
  providerName: providerName(c.communityProvider),
  communityCount: communitiesStore.allCommunities.filter(community => community.ecn === c.ecn).length,
  feeCount: (c.serviceFees || []).length,
})));

function openCompany(event, { item }) {
  router.push({ name: 'communityCompanyForm', params: { ecn: item.ecn } });
}
</script>

<template>
  <v-container class="pa-0">
    <div class="d-flex justify-space-between align-center mb-4">
      <p class="textHeadline flex-grow-1">{{ t('communityCompanies.title') }}</p>
    </div>

    <v-data-table
      class="elevation-2 mainViewContent"
      :headers="tableHeader"
      :items="rows"
      :sort-by="sortBy"
      :loading="companiesStore.allCommunityCompaniesLoading"
      :items-per-page="25"
      density="comfortable"
      @click:row="openCompany"
    />
  </v-container>
</template>
